<template>
  <div class="desc">
    <div class="container">
      <div class="progress-bar">
        <p class="bar-b"><img src="../../assets/images/jdt@2x.png" alt="" class="bar"></p>
        <div class="txt">
          <div class="t1">
            <h3 class="title tit">登录企业网银</h3>
            <p class="t">电脑登陆企业网银后，进入[客户服务] - [微信注册]</p>
          </div>
          <div class="t1">
            <h3 class="title">扫描二维码</h3>
            <p class="t">点击下方【绑定】按钮，扫描网银画面上的二维码</p>
          </div>
          <div class="t1">
            <h3 class="title">输入动态密码</h3>
            <p class="t">请在网银页面输入您的邮箱收到的动态密码</p>
          </div>
          <div class="t1">
            <h3 class="title ">点击【确定】按钮完成</h3>
          </div>
        </div>
      </div>
      <button class="btn" @click='scanCode' :disabled="bindDisabled">绑定</button>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'descScan',
    data(){
        return{
            orderData:"",  //接收酷屏通过URL传过来的数据
            configContent: {}, // 微信获取
            token: '',
            extcid: '',
            extuid: '',
            appid: '',
            code: '',
            ticketNum: {},
            qrCode: '',
            openId: '',
            bindDisabled: false,
            subState: ''

        }
    },
    methods: {
      // 调用wx接口要获取的数据
      queryScanQRCodeInfo(){
        let reqHead = {
            // orderNo:val,
            // TransId:"QueryIpayOrder",
        }
        let url = location.href.split('#')[0]
        let reqBody = {}
        let params = {
          url:url
        }
        this.$api.post("/queryScanQRCodeInfo.do",params).then(res => {
           if(res.rejCode == '000000') {
              this.configContent = res
              console.log(this.configContent)
              this.signWX()
           } else {
              this.$dialog.alert({
                title:"温馨提示",
                content:res.rejMsg
              })
           }
        })
      },
      // 获取微信openId
    getOpenId(code) {
      let reqHead = {
          // orderNo:val,
          // TransId:"QueryIpayOrder",
      }
      let reqBody = {}
      let params = {
        code: code
      }
      this.$api.post("/getOpenId.do",params).then(res => {
        if (res.openid != '') {
          this.openId = res.openid
          this.subState = res.subState
          // alert(JSON.stringify(res))
          if (this.subState == '1') {
            this.$dialog.alert({
              title:"温馨提示",
              content:' 您尚未关注我行的官方微信账号,请先关注后再扫描二维码进行绑定,谢谢',
              confirmText: "确定",
              onConfirm: () => {
                wx.closeWindow()
              }
            })
          } else {
            this.qryWXbindInfo()
          }
        } else {
          this.$dialog.alert({
            title:"温馨提示",
            content:res.errmsg
          })
        }
    }).catch(res => {
    })
    },
      // 判断是否绑定过
      qryWXbindInfo(){
        let reqHead = {
            // orderNo:val,
            // TransId:"QueryIpayOrder",
        }
        let reqBody = {}
        let params = {
          openId: this.openId
        }
        this.$api.post("/qryWXbindInfo.do",params).then(res => {
           if(res.rejCode == '000000') {
              // 刚进来页面就检查wx配置
              this.queryScanQRCodeInfo()
           } else {
              this.$dialog.alert({
                title:"温馨提示",
                content:res.rejMsg,
                confirmText: "确定",
                onConfirm: () => {
                  wx.closeWindow()
                }
              })
           }
        })
      },
      // 调微信扫一扫
      signWX () {
        let _this = this
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: this.configContent.appid, // 必填，公众号的唯一标识
          timestamp: this.configContent.timestamp, // 必填，生成签名的时间戳
          nonceStr: this.configContent.nonceStr, // 必填，生成签名的随机串
          signature: this.configContent.signature, // 必填，签名
          jsApiList: ['scanQRCode','closeWindow'] // 必填，需要使用的JS接口列表
        })
      },
      scanCode() {
        this.bindDisabled = true
        let _this = this
        // var code = _this.getUrlParam('code') // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
        wx.ready(function () {
          wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
            success: function (res) {
              _this.bindDisabled = false
              _this.ticketNum = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
              _this.token =  _this.ticketNum.split('?')[1].split('&')[0].split('=')[1]
              _this.extcid =  _this.ticketNum.split('?')[1].split('&')[1].split('=')[1]
              _this.extuid =  _this.ticketNum.split('?')[1].split('&')[2].split('=')[1]
              _this.updQrCodeState() //把code传给后台获取用户信息
            },
            error: function(res){
              _this.bindDisabled = false
            }
          });
        });
      },
      // 正则表达式获取地址栏参数
      getUrlParam(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r =  window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
      },
      getCode() {
        var code = this.getUrlParam('code') // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
        this.getOpenId(code)
      },
      // 查询二维码状态
      updQrCodeState() {
        let reqHead = {
            // orderNo:val,
            // TransId:"QueryIpayOrder",
        }
        let reqBody = {}
        let params = {
          qrCode: this.token,
          extcustomerid: this.extcid,
          extuserid: this.extuid,
          openId: this.openId
        }
        this.$api.post("/updQrCodeState.do",params).then(res => {
          // if (res.openId != '' && res.openId != null) {
          //   this.$router.push({
          //     name: 'desc',
          //     params: {
          //     }
          //   })
          // }
          // alert(JSON.stringify(res))
          if (res.rejCode == '000000') {
            this.$router.push({
              name: 'desc',
              params: {
              }
            })
          } else {
            this.$dialog.alert({
              title:"温馨提示",
              content:res.rejMsg
            })
          }
      })
      },
    },
    mounted () {
      this.getCode()

    },
    created () {
      this.orderData = this.$route.query.data;
    },
}
</script>

<style scoped>
.desc{
  background-color: #efeff4;
  height: 100%;
  padding-top: 30px;
}
.container{
  background-color: #efeff4;
  height: 100%;
  padding-top: 30px;
  position: relative;
}
.progress-bar{
  padding:90px 45px 0;
  height: 788px;
  display: flex;
  background-color: #fff;
  box-shadow: 10px 0px 20px #888888;
}
.bar-b{
  width: 40px;
  margin: 0;
}
.bar{
  width: 40px;
  height: 550px;
}
.txt{
  flex: 1;
  margin-left:70px;
}
.title{
  font-size: 30px;
  font-weight: bold;
  color: #007C7D;
}
.t1{

}
.t1 .title{
  margin:5px 0 40px;
  font-size: 30px;
  font-weight: bold;
  color: #000000;
  opacity: 0.8;
}
.t1 .tit{
  color: #007C7D;
}
.t1 .t{
  margin:25px 0 20px;
  font-size: 26px;
  font-weight: bold;
  color: #000000;
  opacity: 0.7;
}
.btn{
  font-size: 40px;
  font-weight: bold;
  color: #FFFFFF;
  width: 650px;
  height: 90px;
  text-align: center;
  line-height: 90px;
  border-radius: 45px;
  display: block;
  margin: 60px auto 0;
  background-color: #007C7D;
}
.md-dialog .md-dialog-body{
  text-align: left;
  color: #f00!important;
}
</style>



// WEBPACK FOOTER //
// src/views/descScan/descScan.vue